// eslint-disable-next-line no-restricted-imports
import type { NotificationGroupResponse } from 'app/gamma/src/types/responses';
// eslint-disable-next-line no-restricted-imports
import { normalizeReactionsFromNotificationGroups } from 'app/gamma/src/api/normalizers/notification';
import { reactionsState } from './reactionsState';

export const loadReactionsFromNotifications = (
  notificationGroupsResponse: NotificationGroupResponse[],
) => {
  const reactionsModel = normalizeReactionsFromNotificationGroups(
    notificationGroupsResponse,
  );
  reactionsModel.forEach((reactionModel) => {
    const idModel = reactionModel.idModel;

    if (!reactionsState.value.reactions[idModel]) {
      reactionsState.setValue({
        ...reactionsState.value,
        reactions: {
          ...reactionsState.value.reactions,
          [idModel]: [],
        },
      });
    }

    if (
      !reactionsState.value.reactions[idModel].some(
        (reaction) => reaction.id === reactionModel.id,
      )
    ) {
      reactionsState.setValue({
        ...reactionsState.value,
        reactions: {
          ...reactionsState.value.reactions,
          [idModel]: [
            ...reactionsState.value.reactions[idModel],
            reactionModel,
          ],
        },
      });
    }
  });
};
